export default __webpack_public_path__ + "static/media/brew-busd.5de0299b.svg";